var _module_exports = "<ng-transclude class=\"radio-group-items\"></ng-transclude>";;
var path = '/workspace/src/app/common/ui/form/radio-group/radio-group.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;